export default __webpack_public_path__ + "static/media/tmp_banner_image02.8577a390.png";